import React from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton, Avatar } from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import EditRounded from "@mui/icons-material/EditRounded";

const FIELDS = [
    { key: "employeeCode", label: "Employee code" },
    { key: "designation", label: "Designation" },
    { key: "department", label: "Department" },
    { key: "emailID", label: "Email" },
    { key: "mobile", label: "Mobile" },
    { key: "managerName", label: "Manager" },
    { key: "managerEmail", label: "Manager email" },
    { key: "officeLocation", label: "Office" },
    { key: "workLocation", label: "Work location" },
    { key: "gender", label: "Gender" },
];

const EmployeeDetail = ({ employee, onClose, onEdit }) => (
    <Dialog open={Boolean(employee)} onClose={onClose} fullWidth maxWidth="sm" className="wh-dialog">
        {employee && (
            <>
                <div className="wh-dialog-head">
                    <Avatar className="wh-dialog-avatar">
                        {String(employee.employeeName || "?").trim().charAt(0).toUpperCase()}
                    </Avatar>
                    <div className="wh-dialog-headings">
                        <h5>{employee.employeeName}</h5>
                        <p>{employee.designation || "No designation on record"}</p>
                    </div>
                    <IconButton className="wh-dialog-close" onClick={onClose} aria-label="Close">
                        <CloseRounded />
                    </IconButton>
                </div>

                <DialogContent>
                    <dl className="wh-facts">
                        {FIELDS.map((f) => (
                            <div key={f.key}>
                                <dt>{f.label}</dt>
                                <dd>{employee[f.key] || "—"}</dd>
                            </div>
                        ))}
                    </dl>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" color="inherit" onClick={onClose}>Close</Button>
                    <Button variant="contained" startIcon={<EditRounded />} onClick={() => onEdit(employee)}>
                        Edit details
                    </Button>
                </DialogActions>
            </>
        )}
    </Dialog>
);

export default EmployeeDetail;
